import styled from "styled-components";

type MobileProps = { isMobile: boolean };

export const ModalContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

export const ContentGrid = styled.div<MobileProps>`
  display: grid;
  grid-template-columns: ${({ isMobile }: MobileProps) =>
    isMobile ? "1fr" : "1fr 1fr"};
  gap: ${({ isMobile }: MobileProps) => (isMobile ? "0" : "48px")};
  padding: ${({ isMobile }: MobileProps) => (isMobile ? "16px" : "0px")};
`;

export const ImageWrapper = styled.div<{ isMobile: boolean }>`
  position: relative;
  overflow: hidden;
  ${({ isMobile }) => isMobile && `
    width: 100%;
    height: 120px;
    border-radius: 20px;
    margin: 0 auto;
  `}
`;

export const Image = styled.img<{ isMobile: boolean }>`
  width: 100%;
  border-radius: 4px;
  ${({ isMobile }) => !isMobile && `
    height: 100%;
  `}
`;

export const TextContent = styled.div<MobileProps>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: ${({ isMobile }: MobileProps) =>
    isMobile ? "16px" : "100px 16px 16px 0px"};
`;

export const TextColor = styled.span`
  color: #F3451F;
`;

export const Heading = styled.h2`
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  line-height: 1.3;
`;

export const Subheading = styled.p`
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  line-height: 1.6;
  color: #202223;
`;

export const FeatureList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  span {
    font-size: 15px;
    color: #202223;
  }
`;

export const CtaButton = styled.button<MobileProps>`
  padding: 14px 24px;
  width: 100%;
  max-width: ${({ isMobile }: MobileProps) =>
    isMobile ? "100%" : "260px"};
  border-radius: 20px;
  color: white;
  background-color: #F3451F;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color:rgb(246, 88, 53);
  }
`;

export const ContinueButton = styled.button<MobileProps>`
  margin-top: ${({ isMobile }: MobileProps) =>
    isMobile ? "15px" : "0px"};
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: ${({ isMobile }: MobileProps) =>
    isMobile ? "center" : "flex-end"};
  align-self: ${({ isMobile }: MobileProps) =>
    isMobile ? "stretch" : "flex-end"};
  color: #8f949c;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 50px 15px;
`;